<svelte:options customElement="hb-uploader" />

<script lang="ts">
  import pkg from "../../../package.json";
  import axios, { type AxiosRequestConfig } from "axios";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import parseStyle from "style-to-object";
  let parsedStyle: { [x: string]: string } = $state({});
  import { styleSetup as dialogStyleSetup } from "../dialog/extra/docs";
  import type { Events as DialogEvents } from "../dialog/types/webcomponent.type";

  import type { Component } from "./types/webcomponent.type";
  let dialogStyleToSet: string = $state("");

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  addComponent({ repoName: "@htmlbricks/hb-dialog", version: pkg.version });

  let {
    id = "",
    // style = "",
    upload_id = undefined,

    fetch_data = undefined,
  }: Component = $props();

  let total: number = $state(0);
  let loaded: number = $state(0);
  let completed: boolean = $state(false);
  let errorMessage: string | null = $state(null);
  $effect(() => {
    if (!upload_id) upload_id = id + "_dialog";
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   dialogStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     dialogStyleSetup?.vars
    //   );
    // }
    if (!completed) completed = false;

    try {
      if (fetch_data && typeof fetch_data === "string")
        fetch_data = JSON.parse(fetch_data);
    } catch (err) {
      console.error(err);
    }
  });

  async function onModalOpened() {
    function onRequestError(err: Error) {
      console.error(err);
      errorMessage = err?.message || "upload error";

      dispatch("uploadError", { completed, id: upload_id, error: err });
    }
    loaded = 0;
    try {
      if (fetch_data) {
        const axiosConfig: AxiosRequestConfig = {
          url: fetch_data.url,
          data: fetch_data.data,
          method: fetch_data.method || "POST",
          headers: fetch_data.headers || {},
          onUploadProgress: (p) => {
            total = p?.total || 0;
            loaded = p?.loaded || 0;
          },
        };

        await axios.request(axiosConfig);
        return dispatch("uploadComplete", { completed, id: upload_id });
      } else {
        errorMessage = "No fetch data provided";
        return onRequestError(new Error(errorMessage));
      }
    } catch (error: any) {
      console.error("upload error ", error);

      return onRequestError(error);
    }
  }

  function dialogShowEvent(d: DialogEvents["modalShow"]) {
    errorMessage = null;

    if (d.show) {
      if (fetch_data?.url) onModalOpened().catch(console.error);
    }
    dispatch("modalShow", d);
  }
</script>

<hb-dialog
  style={dialogStyleToSet}
  id={upload_id}
  show={fetch_data?.url || (loaded && total) ? "yes" : "no"}
  onmodalShow={(d: { detail: DialogEvents["modalShow"] }) =>
    dialogShowEvent(d.detail)}
>
  <span slot="title">
    <slot name="title">Uploading</slot>
  </span>
  <div slot="body-content">
    {#if !total && !errorMessage}
      <div class="progress">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100"
          style="width: 100%"
        ></div>
      </div>
    {:else if !errorMessage}
      <div class="progress">
        <div
          class="progress-bar"
          style="width:{Math.round((loaded / total) * 100)}%"
          role="progressbar"
          aria-valuenow={Math.round((loaded / total) * 100)}
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {Math.round((loaded / total) * 100)}%
        </div>
      </div>
    {:else if errorMessage}
      {errorMessage}
    {/if}
  </div>
  <span slot="modal-footer"></span>
</hb-dialog>

<style lang="scss">
  @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";
</style>
